export default "__VITE_ASSET__BEvgzqK$__"